export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const URL_FACTURA_ELECTRONICA =
  'WS/Servicios/FacturacionElectronica.php';
